var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-overlay',{attrs:{"show":_vm.showOverlay,"rounded":"sm"}},[_c('div',{staticClass:"home",attrs:{"id":"home"}},[_c('left-menu-bar'),_c('div',{staticClass:"main"},[_c('top-menu-bar'),_c('main',{staticClass:"content"},[_c('router-view')],1),_c('Footer')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }